import React, { ReactNode } from 'react';
import { WizardContext } from '../../../context/wizardContext';

export interface WizardProps {
  setStepTo?: number | null;
}

interface WizardState {
  currentStepNumber: number;
  next: () => void;
  prev: () => void;
  goto: (step: number | string) => void;
  mounted: boolean;
}

export class Wizard extends React.Component<WizardProps, WizardState> {
  state: WizardState = {
    mounted: false,
    currentStepNumber: 0,
    next: () => {
      if (this.outOfBounds(this.state.currentStepNumber + 1)) return;

      this.setState((state: WizardState) => ({
        currentStepNumber: state.currentStepNumber + 1,
      }));
    },
    prev: () => {
      if (this.state.currentStepNumber === 0) return;
      this.setState((state: WizardState) => ({
        currentStepNumber: state.currentStepNumber - 1,
      }));
    },
    goto: (step: number | string) => {
      if (typeof step === 'string') {
        const steps = this.getSteps().map(step => {
          const reactChild: React.ReactElement<any> =
            step as React.ReactElement<any>;
          return reactChild.props.id;
        });

        const stepNumber = steps.indexOf(step);
        if (stepNumber !== -1) {
          this.setState((state: WizardState) => ({
            currentStepNumber: stepNumber,
          }));
        }
      } else {
        if (step - 1 === this.state.currentStepNumber) return;
        if (this.outOfBounds(step - 1)) return;
        this.setState((state: WizardState) => ({
          currentStepNumber: step - 1,
        }));
      }
    },
  };

  componentDidMount() {
    const currentStepNumber = this.props.setStepTo
      ? this.props.setStepTo - 1
      : 0;

    this.setState({
      currentStepNumber,
      mounted: true,
    });
  }

  getSteps(): ReactNode[] {
    return React.Children.toArray(this.props.children).filter(child => {
      const reactChild: React.ReactElement<any> =
        child as React.ReactElement<any>;
      return reactChild.props.type === 'Step';
    });
  }

  outOfBounds(step: number) {
    const numberOfSteps = this.getSteps().length - 1;

    return step < 1 || step > numberOfSteps;
  }

  render() {
    return this.state.mounted ? (
      <WizardContext.Provider value={this.state}>
        {this.getSteps()[this.state.currentStepNumber]}
      </WizardContext.Provider>
    ) : null;
  }
}

export interface StepProps {
  id?: string;
  type: string;
}

export class Step extends React.Component<StepProps> {
  static defaultProps = {
    type: 'Step',
  } as StepProps;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id='step' style={{ height: '100%', display: 'flex' }}>
        {this.props.children}
      </div>
    );
  }
}
